import React from 'react';
import { Dialog, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import welcomeImage from '../../assets/images/welcome.png';

interface WelcomePopOverProps {
    open: boolean;
    onClose: () => void;
    anchorEl: HTMLElement | null;
}

const WelcomePopOver: React.FC<WelcomePopOverProps> = ({ open, onClose, anchorEl }) => {
    const handleClose = (event: object, reason: string) => {
        if (reason === 'backdropClick') {
            return;
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={false}
            disableEscapeKeyDown
            sx={{zIndex:9999}}
            PaperProps={{
                sx: {
                    position: 'relative',
                    width: '600px',
                    overflow: 'hidden',
                    borderRadius: '8px',
                }
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    zIndex: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    }
                }}
            >
                <CloseIcon />
            </IconButton>
            <Box
                component="img"
                src={welcomeImage}
                alt="Welcome"
                sx={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                }}
            />
        </Dialog>
    );
};

export default WelcomePopOver; 